import $ from 'jquery'

//import '@babel/polyfill'
import 'babel-polyfill'

import Foundation from './_foundation'
// import 'motion-ui/dist/motion-ui'
// import AOS from 'aos'
import throttle from 'lodash/throttle';
// import '../../node_modules/jquery-parallax.js/parallax.min.js'
// import { inlineSVG } from './_inline-svg'
import { lazyImages, lazyBackgrounds, lazyInterchange, lazyVideos } from './_lazy-load'
// import { smoothScrollOnPageLoad } from './_smoothScrollOnPageLoad';
import './_skip-link-focus-fix'
// import './_acf-map'
import './_fixed-header'
import './_header-height'
import './_hero-slider'
// import './_notification'
import './_scroll-to-top'
import './_slick'
import './_off-canvas'
// import './_faqs_accordion'
// import './_fragmentURLs'

/* Additional Scripts */
// import { randomString } from './_random-string'
import './_ie'
import { equalHeights } from './_equal-height'

// Foundation
$(document).foundation();

// Inline SVG
// inlineSVG();

// Smooth Scroll on page load
// smoothScrollOnPageLoad();

// Lazy-load on DOMContentLoaded
window.addEventListener( 'DOMContentLoaded', function() {

    lazyImages();
    lazyBackgrounds();
    lazyVideos();
    // lazyOembeds();
    lazyInterchange();

}, false);

// Lazy-load on scroll event
window.addEventListener( 'scroll', throttle( lazyImages, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyBackgrounds, 75 ), { passive: true } );
// window.addEventListener( 'scroll', throttle( lazyOembeds, 75 ), { passive: true } );
window.addEventListener( 'scroll', throttle( lazyInterchange, 75 ), { passive: true } );

// AOS
// AOS.init();

// Equal Heights
let $bottles_cta = $('.custom-stock-bottles-cta .flexbackground');
if ( $bottles_cta.length ) {
    setTimeout( () => {
        if ( Foundation.MediaQuery.atLeast('medium') ) {
            equalHeights('.custom-stock-bottles-cta .flexbackground');
        }
    }, 1500 );
}

// Flexible Careers Contact
// jQuery( function( $ ) {
//     let $careers_dropdown = $( '.js-career-dropdown' ); 
//     let $careers_contact_button = $( '.js-contact-button' ); 
//     let $mailto = $careers_contact_button ? $careers_contact_button.attr('href') : '';
//     if ( $careers_dropdown.length || $careers_contact_button ) {
//         $careers_dropdown.change( function( event ) {
//             let $mailto_with_subject =  `${$mailto}?subject=${this.value.trim()}&body=Please attach a copy of your resume and cover letter.`;
//             $careers_contact_button.attr( 'href', $mailto_with_subject );
//         } );
//     }
// } );

// KLUDGE: IE/Edge Video
jQuery( function( $ ) {
    setTimeout( function() {
        if ( 
            ( $('body').hasClass('is-edge') || $('body').hasClass('is-ie') ) 
            && $( '.hero-slider-container__video' ).length 
        ) {
            $( '.hero-slider-container__video' ).get(0).play();
            $( '.hero-slider-container__video' ).css('opacity', 1);
        }
    }, 2000 );
} );

// Product Single Neck Finishes
// jQuery( function( $ ) {
//     let $choice_button = $('.choice-box.--button > button');
//     let choices_arr = []; 

//     function productNeckFinish( event ) {
//         event.preventDefault();

//         // Toggle class
//         $(this).toggleClass('is-selected');
        
//         // Get the text of the clicked button
//         var text =  $(this).text();
        
//         // Call back for the array.find() method
//         // Check if the choice (var text) is in the array (let choices_arr)
//         function findChoiceInArray( element, index, arr, thisArg ) {
            
//             return element == text;
            
//         }

//         if ( choices_arr.find( findChoiceInArray ) ) {
           
//             // If the text is found in the array then get the index... 
//             let index = choices_arr.indexOf( $(this).text() );
            
//             // ... and remove the text based on the index
//             choices_arr.splice( index, 1 );

//         } else {

//             // Add text to the array
//             choices_arr.push( $(this).text() );

//         }
        
//         $('#input_3_5').val( $('#item-number').text() );
        
//         if ( choices_arr.length ) {
//             $('#input_3_6').val( choices_arr.join() );
//         } else {
//             $('#input_3_6').val('None selected');
//         }

//     }

//     $choice_button.on( 'click', productNeckFinish );

//     let $getintouch = $('[data-open="product_modal"]');

//     if ( $getintouch ) {

//         $getintouch.on( 'click', function( event ) {
//             event.preventDefault();
//         } );

//     }
// } );

// Accordion for the facetWP filters
// $('.js-facet-header').click(function(e) {
//     e.preventDefault();

//     let $question = $(this);
//     let $answer = $question.siblings( '.js-facet-options' );

//     $question.stop().toggleClass( 'is-open' );
//     $answer.stop().slideToggle();
// });

// FacetWP
// (function($) {
//     $(document).on('facetwp-refresh', function() {
        
//         let $filter_reset = $('#nv-facetwp-reset');
        
//         // If a package type is selected then show the filter reset
//         let packaging_type_arr = FWP.facets['packaging_type'];
//         let material_arr = FWP.facets['material'];
//         let neck_finish_arr = FWP.facets['neck_finish'];
//         let capacity_arr = FWP.facets['polyblow_bottles_capacity'];
        
//         if ( 
//             packaging_type_arr.length >= 1
//             || material_arr.length >= 1
//             || neck_finish_arr.length >= 1
//             || capacity_arr.length >= 1
//         ) {
        
//             $filter_reset.show();
        
//         } else {
        
//             $filter_reset.hide();
        
//         }

//      });
// })(jQuery);

// Set top offset for the mobile product filters on the Stock Bottles page
// (function($) {
//     if ( $('body').hasClass('is-mobile') && ! $('body').hasClass('is-tablet') ) {
//         var $header = $( '.site-header' );

//         setTimeout( function() {
//             var hero_height = $header.outerHeight();
//             $('#mobile-product-filters').css('top', hero_height+'px');
//         }, 500 );

//         // Set top offset for the mobile product filters on the Stock Bottles page
//         $('#mobile-product-filters button').click( function() {
//             $('body').addClass('prevent-scrolling');
//         });

//         $('#mobile-product-search-menu .close-button, #mobile-product-filters-menu .close-button').click(function() {
//             $('body').removeClass('prevent-scrolling');
//         });


//     }
// })(jQuery);

// Flexible Form - Custom Form Title
// (function($) {
//     var $js_custom_form_title = $('.js-custom-form-title');
//     var form_title = '';
//     if ($js_custom_form_title) {
//         form_title = `<div class="gform_heading">
//                           <h3 class="gform_title">${$js_custom_form_title.text()}</h3>
//                       </div>`;

//         // Form has loaded
//         jQuery(document).on('gform_post_render', function(){
//             $('.gform_wrapper form').prepend(form_title);
//         });
//     }
// })(jQuery);




